export default {"src":"/_next/static/media/trazado-giv.3fad92e4.svg","height":44,"width":76,"blurWidth":0,"blurHeight":0};